/**
 * AI消しゴムAPIサービス
 * バックエンドのAI消しゴムAPIと通信するサービス
 */
import axios from "axios";
import { OpenAPI } from "./core/OpenAPI";
import { getCsrfToken } from "../utils/csrf";

export interface AIEraserRequest {
  masked_image: File;
  stub_id: string;
}

export interface AIEraserResponse {
  success: boolean;
  result_image_url?: string;
  render_id?: string;
  usage_count?: number;
  remaining_count?: number;
  message?: string;
  error_detail?: string;
}

export const AIEraserService = {
  /**
   * AI消しゴム処理を実行
   * @param params リクエストパラメータ
   * @returns 処理結果
   */
  processAIEraser: async (params: {
    formData: AIEraserRequest;
  }): Promise<{ data: AIEraserResponse }> => {
    const form = new FormData();
    form.append("masked_image", params.formData.masked_image);
    form.append("stub_id", params.formData.stub_id);

    try {
      const response = await axios.post<AIEraserResponse>(
        `${OpenAPI.BASE}/api/room-designs/ai-eraser/process/`,
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-CSRFToken": getCsrfToken(),
          },
          withCredentials: true,
        },
      );
      return response;
    } catch (error) {
      console.error("AI消しゴムAPI呼び出しエラー:", error);
      // エラーレスポンスがある場合はそれを返す
      if (axios.isAxiosError(error) && error.response) {
        console.error("エラー詳細:", {
          status: error.response.status,
          data: error.response.data,
          headers: error.response.headers,
        });
        return error.response;
      }
      // ネットワークエラーなどの場合は独自のエラーレスポンスを作成
      return {
        data: {
          success: false,
          message: "ネットワークエラーが発生しました。接続を確認してください。",
          error_detail: error instanceof Error ? error.message : String(error),
        },
      } as { data: AIEraserResponse };
    }
  },
};
